module.exports = __webpack_public_path__ + "static/media/YF24_1.32554046.jpg";